var _g, _path, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProgramDuration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1235:43296)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter0_f_1235:43296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.9993 88.5218C23.8598 88.5218 9.15487 85.6702 9.15487 82.1525C9.15487 78.6348 23.8598 75.7832 41.9993 75.7832C60.1388 75.7832 74.8438 78.6348 74.8438 82.1525C74.8438 85.6702 60.1388 88.5218 41.9993 88.5218Z",
    fill: "url(#paint0_linear_1235:43296)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9213 40.9379C25.7176 21.0384 43.5499 8.53961 58.7468 13.0078C59.2377 13.1499 59.7211 13.3143 60.193 13.4885L60.214 13.4626L69.2591 16.3447C54.1494 12.2079 36.5689 24.6593 29.8155 44.3788C23.2074 63.7044 29.4456 82.8852 43.7477 88.0631L34.2888 85.0834C34.2253 85.0668 34.1654 85.0537 34.1036 85.0344C18.9195 80.5605 12.1141 60.8179 18.9213 40.9379Z",
    fill: "url(#paint1_linear_1235:43296)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8279 44.4519C22.9731 64.3221 29.7709 84.0337 45.0091 88.4758C60.2474 92.918 78.1557 80.4122 85.0076 60.5405C91.8594 40.6688 85.0661 20.956 69.8241 16.5171C54.582 12.0783 36.6821 24.5795 29.8279 44.4519Z",
    fill: "url(#paint2_linear_1235:43296)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1235:43296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.7686 45.535C29.0323 62.2926 34.7513 78.936 47.5686 82.6899C60.3858 86.4437 75.4371 75.9094 81.1858 59.1529C86.9346 42.3964 81.1997 25.764 68.3811 22.0061C55.5626 18.2481 40.5164 28.7833 34.7686 45.535Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1235:43296)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1235:43296",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 31,
    width: 33,
    height: 44
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2007 70.2316L44.7876 44.9964C44.8636 41.7325 46.4947 38.6418 49.3175 36.9717C55.1299 33.5328 63.3156 29.9387 70.3438 32.7847C77.0202 35.4882 78.1354 43.8796 75.5442 50.6528C72.9531 57.4259 60.6892 61.5435 60.6892 61.5435L60.602 65.2937C60.4678 71.0626 55.2058 72.8182 49.115 74.2344C46.5659 74.827 44.1399 72.8417 44.2007 70.2316Z",
    fill: "#C4C4C4"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1235:43296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.0255 48.8235L70.7871 29.6478L86.6402 56.4669L43.0893 80.0642L33.0255 48.8235Z",
    fill: "url(#paint3_linear_1235:43296)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 42.2787,
    height: 28.7212,
    transform: "matrix(0.894545 -0.454257 0.50706 0.857802 35.8672 28.1777)",
    fill: "#00E5CC"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1235:43296",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 32,
    width: 34,
    height: 45
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7608 71.8875L46.3668 45.8276C46.4427 42.564 48.072 39.4716 50.8981 37.8075C56.5555 34.4761 64.4726 31.0376 71.2766 33.7932C77.7833 36.4285 78.8702 44.6079 76.3449 51.21C73.8196 57.812 61.8674 61.8255 61.8674 61.8255L61.7824 65.481C61.6806 69.8599 56.5264 73.3466 50.5828 75.5407C48.125 76.448 45.7001 74.4977 45.7608 71.8875Z",
    fill: "#C4C4C4",
    stroke: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1235:43296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.8537 60.3755L33.8375 60.0281L34.3504 39.4513C34.5323 32.1531 41.027 26.3162 48.8614 26.41L63.696 26.5876C73.7066 26.7075 81.6424 34.3732 81.41 43.6987C81.1775 53.0242 72.8644 60.4954 62.8537 60.3755Z",
    fill: "url(#paint4_linear_1235:43296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4805 58.3595L51.2047 47.9196L45.3443 41.1979C45.5261 33.9059 41.453 37.0581 49.2812 37.1518C49.2812 37.1518 47.4847 43.2701 58.3394 47.4933C69.1941 51.7165 73.5385 53.3035 76.6343 61.0154C76.402 70.3331 78.4832 58.4793 68.4805 58.3595Z",
    fill: "url(#paint5_linear_1235:43296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7891 31.5586C51.413 34.3994 57.084 38.0115 69.4274 40.4503C76.5464 41.8756 82.2883 44.4945 86.8608 47.4451C84.2491 38.5104 75.4942 31.8791 64.9978 31.7531L48.7891 31.5586Z",
    fill: "url(#paint6_linear_1235:43296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7891 31.5586C51.413 34.3994 57.084 38.0115 69.4274 40.4503C76.5464 41.8756 82.2883 44.4945 86.8608 47.4451C84.2491 38.5104 75.4942 31.8791 64.9978 31.7531L48.7891 31.5586Z",
    fill: "url(#paint7_linear_1235:43296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7031 30.5215C50.3271 33.3623 55.998 36.9744 68.3414 39.4132C75.4605 40.8385 81.2024 43.4574 85.7748 46.408C83.1632 37.4733 74.4082 30.8419 63.9119 30.716L47.7031 30.5215Z",
    fill: "url(#paint8_linear_1235:43296)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_1235:43296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.9102 30.5586C52.5341 33.3994 58.2051 37.0115 70.5485 39.4503C77.6675 40.8756 83.4095 43.4945 87.9819 46.4451C85.3702 37.5104 76.6153 30.8791 66.119 30.7531L49.9102 30.5586Z",
    fill: "url(#paint9_linear_1235:43296)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_1235:43296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.9382 34.2535C58.787 33.589 64.4501 32.7988 65.769 32.8146C67.4175 32.8344 75.6348 33.9631 77.1299 40.1608",
    stroke: "#00E5CC",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.3477 47.8125L45.965 63.1873L45.8563 67.5537C45.7308 72.5967 51.3035 75.9546 56.1643 73.7676L57.7515 73.0483C65.688 69.4525 68.0058 59.8791 59.7685 57.1658C53.8656 55.2495 46.2244 52.7632 46.3477 47.8125Z",
    fill: "url(#paint10_linear_1235:43296)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_1235:43296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.1714 47.0014C49.5292 43.7758 48.6129 39.6208 49.2654 37.6592C46.6142 39.4435 45.2863 43.3669 45.2047 46.6398L44.8165 62.2119L66.7614 62.4746C69.9982 62.5133 72.987 61.5004 75.362 59.7896C74.3986 52.2072 65.227 51.3812 56.1714 47.0014Z",
    fill: "url(#paint11_linear_1235:43296)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.0464 48.0014C48.4042 44.7758 46.9399 40.6143 47.5925 38.6526C44.9413 40.4369 44.1613 44.3669 44.0797 47.6398L43.6915 63.2119L65.6364 63.4746C68.8733 63.5133 71.862 62.5005 74.237 60.7896C73.2736 53.2072 64.102 52.3812 55.0464 48.0014Z",
    fill: "url(#paint12_linear_1235:43296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3819 54.4782C45.0272 51.799 41.2267 46.6296 41.879 44.6687C39.229 46.4523 37.4564 49.3457 37.3748 52.6173L36.9868 68.1831L58.9221 68.4457C62.1575 68.4844 61.4904 68.6393 63.8645 66.9291C64.0684 58.7466 55.3176 58.1302 49.3819 54.4782Z",
    fill: "url(#paint13_linear_1235:43296)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_1235:43296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.1055 49.8125L43.7228 65.1873L43.6141 69.5537C43.4886 74.5967 49.0614 77.9547 53.9221 75.7676L55.5094 75.0483C63.4459 71.4525 65.7636 61.8791 57.5264 59.1658C51.6234 57.2495 43.9822 54.7632 44.1055 49.8125Z",
    fill: "url(#paint14_linear_1235:43296)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.082 50.832L43.6992 66.209L43.5905 70.576C43.4649 75.6197 46.7998 77.5141 51.6624 75.3268L55.4903 76.0714C63.4299 72.4751 65.7485 62.9003 57.5081 60.1866C51.6029 58.2701 43.9588 55.7834 44.082 50.832Z",
    fill: "url(#paint15_linear_1235:43296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1289 52.8848L44.8348 64.7085L44.6603 71.7201C44.5639 75.5984 46.8702 76.8796 51.0579 75.2031C51.0579 75.2031 51.6873 75.2106 56.0733 71.8571C60.4593 68.5035 61.2538 62.7787 56.9403 60.6848C51.8441 59.2044 45.0342 56.692 45.1289 52.8848Z",
    fill: "url(#paint16_linear_1235:43296)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_1235:43296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.2969 55.5625C53.6007 57.9476 68.9352 61.8742 57.7918 71.9468",
    stroke: "url(#paint17_linear_1235:43296)",
    strokeLinecap: "round"
  }))))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.3834 53.8243L59.303 33.5039L60.9812 34.6184L61.0566 54.1953L61.0625 54.6331L61.0583 54.6358L61.0625 55.7287L60.2227 55.1703L48.3331 62.7748L46.9863 61.9041L59.3834 53.8243Z",
    fill: "url(#paint18_linear_1235:43296)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3036 33.4867L60.8367 32.9609L62.3828 34.0451L60.8367 34.5871L59.3036 33.4867Z",
    fill: "url(#paint19_linear_1235:43296)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1579 62.7078L60.93 54.3452L60.8533 34.5689L62.4043 34.0449L62.5273 55.259L62.5041 55.2741V55.2893L62.453 55.3044L48.1579 64.6718V62.7078Z",
    fill: "url(#paint20_linear_1235:43296)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1602 64.6718L46.9871 63.9257V61.877L48.1602 62.6186V64.6718Z",
    fill: "url(#paint21_linear_1235:43296)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1293 47.8838C37.3224 33.7602 54.4629 13.4907 72.8039 24.2286",
    stroke: "url(#paint22_linear_1235:43296)",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8569 45.0404C33.05 30.9169 50.6499 11.2796 69.7114 16.5647",
    stroke: "url(#paint23_linear_1235:43296)",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3214 59.1149C79.1284 73.2385 60.9266 92.3486 42.5855 81.6107",
    stroke: "url(#paint24_linear_1235:43296)",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1235:43296",
    x: 1.15625,
    y: 67.7832,
    width: 81.6875,
    height: 28.7383,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_1235:43296"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1235:43296",
    x: 32.5391,
    y: 21.2461,
    width: 50.8789,
    height: 66.2031,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1235:43296"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1235:43296",
    x: 43.1992,
    y: 30.7539,
    width: 34.6328,
    height: 44.5859,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_1235:43296"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1235:43296",
    x: 48.9102,
    y: 29.5586,
    width: 40.0703,
    height: 17.8867,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_1235:43296"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_1235:43296",
    x: 55.7891,
    y: 31.6641,
    width: 22.4922,
    height: 9.64648,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_1235:43296"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_1235:43296",
    x: 43.8164,
    y: 36.6602,
    width: 32.5469,
    height: 26.8164,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_1235:43296"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_1235:43296",
    x: 42.6133,
    y: 48.8125,
    width: 21.0781,
    height: 28.6348,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_1235:43296"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_1235:43296",
    x: 52.2969,
    y: 54.5625,
    width: 10.5469,
    height: 18.3848,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_1235:43296"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1235:43296",
    x1: 51.9956,
    y1: 86.0643,
    x2: 50.8309,
    y2: 79.6769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E18BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302693,
    stopColor: "#725BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9665FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1235:43296",
    x1: 57.7158,
    y1: 61.3027,
    x2: 2.28067,
    y2: 55.5764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B28DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#9665FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#725BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1235:43296",
    x1: 90.1451,
    y1: 74.5219,
    x2: 4.06978,
    y2: 50.2212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#321DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269097,
    stopColor: "#5742D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57118,
    stopColor: "#725BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#825DCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1235:43296",
    x1: 54.1408,
    y1: 74.4266,
    x2: 46.7722,
    y2: 51.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C31D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9804,
    stopColor: "#2880FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1235:43296",
    x1: 58.5357,
    y1: 37.2797,
    x2: 72.0286,
    y2: 50.7494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2EAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEFFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1235:43296",
    x1: 59.2003,
    y1: 50.7395,
    x2: 67.9744,
    y2: 41.6784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0885417,
    stopColor: "#0080EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.364583,
    stopColor: "#0080EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01C5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01C5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1235:43296",
    x1: 55.8285,
    y1: 35.7576,
    x2: 75.6361,
    y2: 32.3278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.161458,
    stopColor: "#BBE0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255208,
    stopColor: "#0080EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#01C5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1235:43296",
    x1: 55.8285,
    y1: 35.7576,
    x2: 75.6361,
    y2: 32.3278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.161458,
    stopColor: "#BBE0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255208,
    stopColor: "#0080EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#01C5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1235:43296",
    x1: 55.343,
    y1: 32.6704,
    x2: 75.2778,
    y2: 43.9264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "#00E5CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789253,
    stopColor: "#10DCC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1235:43296",
    x1: 76.536,
    y1: 34.4728,
    x2: 66.8465,
    y2: 37.1487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9358,
    stopColor: "#C1FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1235:43296",
    x1: 47.2744,
    y1: 54.4625,
    x2: 62.1838,
    y2: 63.5898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.161458,
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9804,
    stopColor: "#E2F6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1235:43296",
    x1: 48.6154,
    y1: 41.7456,
    x2: 69.7992,
    y2: 60.4971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.213542,
    stopColor: "#FCA8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869792,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1235:43296",
    x1: 50.7527,
    y1: 43.8082,
    x2: 62.7078,
    y2: 63.6678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1235:43296",
    x1: 44.0449,
    y1: 48.7872,
    x2: 55.9953,
    y2: 68.6384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F093FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1235:43296",
    x1: 45.6036,
    y1: 55.448,
    x2: 62.2389,
    y2: 63.5146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.120578,
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451663,
    stopColor: "#00B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9804,
    stopColor: "#E2F6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1235:43296",
    x1: 53.8241,
    y1: 76.4867,
    x2: 46.4637,
    y2: 57.0666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06D0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9804,
    stopColor: "#E2F6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1235:43296",
    x1: 53.589,
    y1: 72.623,
    x2: 48.4148,
    y2: 57.2711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2EAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9804,
    stopColor: "#E2F6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1235:43296",
    x1: 60.2359,
    y1: 61.2594,
    x2: 55.1717,
    y2: 73.2127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438179,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96858,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1235:43296",
    x1: 55.7062,
    y1: 53.7367,
    x2: 43.3171,
    y2: 50.9101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B28DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#9665FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#725BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1235:43296",
    x1: 61.2111,
    y1: 34.085,
    x2: 59.6332,
    y2: 32.6676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B28DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#C7ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFB5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1235:43296",
    x1: 57.5293,
    y1: 58.7632,
    x2: 51.1902,
    y2: 55.6002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E18BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302693,
    stopColor: "#725BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9665FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1235:43296",
    x1: 48.0122,
    y1: 64.4664,
    x2: 46.2967,
    y2: 63.9796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#321DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269097,
    stopColor: "#5742D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57118,
    stopColor: "#725BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#825DCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1235:43296",
    x1: 75.7558,
    y1: 22.4477,
    x2: 35.2661,
    y2: 51.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502531,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1235:43296",
    x1: 71.4834,
    y1: 19.6043,
    x2: 30.9937,
    y2: 48.3657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502531,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1235:43296",
    x1: 40.2999,
    y1: 83.1568,
    x2: 76.939,
    y2: 55.8735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0889754,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502531,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1235:43296"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramDuration);
export default __webpack_public_path__ + "static/media/program-duration.5683a536.svg";
export { ForwardRef as ReactComponent };